/* global axios */
import ApiClient from './ApiClient';

class SalesTransactionReceiptAPI extends ApiClient {
  constructor() {
    super('sales_transactions', { accountScoped: true });
  }

  path(transactionId, suffix = '') {
    return `${this.url}/${transactionId}/receipt${suffix}`;
  }

  show(transactionId) {
    return axios.get(this.path(transactionId));
  }

  upload(transactionId, file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(this.path(transactionId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  }

  signedUrl(transactionId) {
    return axios.post(this.path(transactionId, '/signed_url'));
  }

  remove(transactionId) {
    return axios.delete(this.path(transactionId));
  }
}

export default new SalesTransactionReceiptAPI();
